<template>
  <main class="main">
    <div class="buttons">
      <router-link :to="{ name: 'fabricant-creation' }" custom v-slot="{ navigate }">
        <ButtonElement color="bordeaux" :icon="PhPlus" @click="navigate">
          Ajouter un fabricant
        </ButtonElement>
      </router-link>
    </div>
    <div class="cards" v-if="fabricants.length">
      <CardComponent
        v-for="fabricant in fabricants"
        :key="fabricant.id"
        :transparent="!fabricant.actif"
        :icon="PhFunnel"
        :title="`${fabricant.nom}${!fabricant.actif ? ' (supprimé)' : ''}`"
      >
        <template #buttons>
          <router-link
            :to="{ name: 'fabricant-modification', params: { id: fabricant.id } }"
            custom
            v-slot="{ navigate }"
          >
            <ButtonElement
              v-if="fabricant.actif"
              color="bordeaux"
              :icon="PhPen"
              size="small"
              @click="navigate"
              >Modifier</ButtonElement
            >
          </router-link>
          <ButtonElement
            color="danger"
            bordered
            :icon="fabricant.actif ? PhTrash : PhRecycle"
            :disabled="!cacheStore.online"
            size="small"
            label-class="tablet-only"
            @click="confirmDeleteFabricant(fabricant)"
            >{{ fabricant.actif ? 'Supprimer' : 'Restaurer' }}</ButtonElement
          >
        </template>
      </CardComponent>
    </div>
    <div class="message" v-else>
      <PhWarning />
      <span>Aucun fabricant n'est enregistré.</span>
    </div>
  </main>
  <ConfirmElement ref="confirmRef" @yes="deleteFabricant" />
</template>

<script setup lang="ts">
import { PhFunnel, PhPen, PhPlus, PhRecycle, PhTrash, PhWarning } from '@phosphor-icons/vue'
import ButtonElement from '@/components/ButtonElement.vue'
import useFetch from '@/composables/useFetch.ts'
import { onMounted, ref, type Ref, useTemplateRef } from 'vue'
import { useLoadingStore } from '@/stores/loading.ts'
import ConfirmElement from '@/components/ConfirmElement.vue'
import CardComponent from '@/components/card/CardComponent.vue'
import type FabricantList from '@/interfaces/Fabricant.ts'
import { useCacheStore } from '@/stores/cache.ts'

// dépendances
const api = useFetch()

// caches
const cacheStore = useCacheStore()
const loadingStore = useLoadingStore()

const fabricants: Ref<FabricantList[]> = ref([])

const confirmRef = useTemplateRef<typeof ConfirmElement>('confirmRef')

async function getFabricants() {
  fabricants.value = await cacheStore.getFabricants()
}

function confirmDeleteFabricant(fabricant: FabricantList) {
  confirmRef.value?.show(
    fabricant,
    `${fabricant.actif ? 'Suppression' : 'Restauration'} d\'un fabricant`,
    `Êtes-vous sûr de vouloir ${fabricant.actif ? 'supprimer' : 'restaurer'} le fabricant <b class="b">${fabricant.nom}</b> ?`,
  )
}

async function deleteFabricant(fabricant: FabricantList) {
  loadingStore.start()
  try {
    await api.delete(`fabricants/${fabricant.id}`)
    await getFabricants()
  } finally {
    loadingStore.stop()
  }
}

onMounted(async () => {
  loadingStore.start()
  try {
    await getFabricants()
  } finally {
    loadingStore.stop()
  }
})
</script>
